/* eslint-disable react/prop-types */

import * as React from 'react'

import { CopyOutlined } from '@ant-design/icons'
import { Typography } from 'antd'

import { flattenNestedObject } from 'shared/helpers'

const CopyableValueRow = ({ column, value }) => {
  const [isHover, setIsHover] = React.useState(false)

  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  return (
    <tr onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <td className="text-muted">{column}</td>
      <td className="a-table-value">
        {' '}
        <Typography.Text
          copyable={{
            icon: (
              <div style={isHover ? null : { visibility: 'hidden' }}>
                <CopyOutlined />
              </div>
            ),
          }}
        >
          {value}
        </Typography.Text>
      </td>
    </tr>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const AttributesTable = ({
  copyable = false,
  data,
  displayedKeys = [],
  excluded = [],
  limit = 100,
  flatten = true,
  tClass = null,
}) => {
  // Set maintains insertion order
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#relation_with_array_objects

  const flattenedData = flatten ? flattenNestedObject(data) : data

  // displayedKeys have priority. merge with remaining keys
  const keys = [...new Set([...displayedKeys, ...Object.keys(flattenedData)])]

  let tClasses = 'table table-sm'
  if (tClass) tClasses += ` ${tClass}`

  return (
    <table className={tClasses}>
      <tbody>
        {keys
          .filter((k) => !excluded.includes(k))
          .slice(0, limit)
          .map(function (key, index) {
            let data = flattenedData[key]

            // ensure complex data types are handled
            if (Array.isArray(data)) data = data.join(', ')
            else if (data && typeof data == 'object' && !React.isValidElement(data)) data = JSON.stringify(data)

            if (copyable && data) return <CopyableValueRow key={index} column={key} value={data} />
            return (
              <tr key={index}>
                <td className="text-muted">{key}</td>
                <td className="a-table-value">{data}</td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export const SimpleTable = ({ data, columns }) => (
  <table style={{ width: '100%' }}>
    <thead>
      <tr>
        {(columns || data[0]) &&
          (columns || Object.keys(data[0])).map(function (key, index) {
            return (
              <th key={index} className="text-muted">
                {key}
              </th>
            )
          })}
      </tr>
    </thead>
    <tbody>
      {!data ||
        (!data[0] && (
          <tr>
            <td colSpan={100} style={{ padding: 20, textAlign: 'center' }}>
              No data
            </td>
          </tr>
        ))}
      {data &&
        data.map(function (row, index) {
          return (
            <tr key={index}>
              {(columns || Object.keys(data[0])).map(function (key, index) {
                return (
                  <td key={index} title={JSON.stringify(row)} style={{ padding: 5, textAlign: 'center' }}>
                    {row[key]}
                  </td>
                )
              })}
            </tr>
          )
        })}
    </tbody>
  </table>
)
